// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   accessToken: null,
//   user: null,
//   accessRights: null, 
// };

// const authReducer = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     setCredentials: (state, action) => {
//       state.accessToken = action.payload.accessToken;

//       if (action.payload.user !== undefined) {
//         state.user = action.payload.user;

//         // Only overwrite accessRights if this payload actually has it.
//         // Prevents a lighter response from wiping out rights we already have.
//         if (action.payload.user.access_rights !== undefined) {
//           state.accessRights = action.payload.user.access_rights;
//         }
//       }

//       // Save to localStorage
//       localStorage.setItem("accessToken", action.payload.accessToken);
//       if (state.accessRights) {
//         localStorage.setItem("accessRights", JSON.stringify(state.accessRights));
//       }
//     },

//     setUserData: (state, action) => {
//       state.user = action.payload.user;

//       // Same guard here — don't null out accessRights if this
//       // particular response doesn't include the field at all.
//       if (action.payload.user?.access_rights !== undefined) {
//         state.accessRights = action.payload.user.access_rights;
//         localStorage.setItem("accessRights", JSON.stringify(state.accessRights));
//       }
//     },

//     resetCredentials: (state) => {
//       state.accessToken = null;
//       state.user = null;
//       state.accessRights = null;
//       localStorage.removeItem("accessToken");
//       localStorage.removeItem("accessRights");
//     },
//   },
// });

// export const { setCredentials, resetCredentials, setUserData } = authReducer.actions;
// export default authReducer.reducer;
// redux/reducers/authReducer.js
import { createSlice } from "@reduxjs/toolkit";
import { setEncryptedItem, removeEncryptedItem } from "../../utils/cryptoStorage";

const initialState = {
  accessToken: null,
  user: null,
  accessRights: null,
};

const authReducer = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, user } = action.payload;

      state.accessToken = accessToken;

      if (user !== undefined) {
        state.user = user;

        if (user.access_rights !== undefined) {
          state.accessRights = user.access_rights;
        }
      }

      // Use plain values from `action.payload`, NOT `state.*` —
      // `state` is an Immer proxy that gets revoked as soon as this
      // reducer returns, so referencing it inside an async callback
      // that resolves later throws "proxy has been revoked".
      setEncryptedItem("accessToken", accessToken);
      if (user?.access_rights !== undefined) {
        setEncryptedItem("accessRights", user.access_rights);
      }
    },

    setUserData: (state, action) => {
      const { user } = action.payload;
      state.user = user;

      if (user?.access_rights !== undefined) {
        state.accessRights = user.access_rights;
        setEncryptedItem("accessRights", user.access_rights);
      }
    },

    resetCredentials: (state) => {
      state.accessToken = null;
      state.user = null;
      state.accessRights = null;
      removeEncryptedItem("accessToken");
      removeEncryptedItem("accessRights");
    },
  },
});

export const { setCredentials, resetCredentials, setUserData } = authReducer.actions;
export default authReducer.reducer;